import React, { useState, useEffect } from 'react';
import {
  Box, Button, Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Chip, MenuItem, Alert, CircularProgress, Grid
} from '@mui/material';
import { Add as AddIcon, Refresh as RefreshIcon } from '@mui/icons-material';
import ModuleHub from '../components/ModuleHub';
import { getTaxRates, createTaxRate, updateTaxRate } from '../../../services/api';

const TaxRatesPage = () => {
  const [rates, setRates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [form, setForm] = useState({ code: '', name: '', rate: 0, tax_type: 'vat', jurisdiction: '' });

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    try { setLoading(true); const r = await getTaxRates(); setRates(r.data || []); }
    catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };

  const handleSave = async () => {
    try {
      if (editItem) await updateTaxRate(editItem.id, form);
      else await createTaxRate(form);
      setDialogOpen(false);
      loadData();
    } catch (err) { setError(err.message); }
  };

  return (
    <ModuleHub moduleId="tax" showFeatures={false}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mb: 2 }}>
        <Button startIcon={<RefreshIcon />} onClick={loadData}>Refresh</Button>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => { setEditItem(null); setForm({ code: '', name: '', rate: 0, tax_type: 'vat', jurisdiction: '' }); setDialogOpen(true); }}>Add Tax Rate</Button>
      </Box>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {loading ? <CircularProgress /> : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead><TableRow><TableCell>Code</TableCell><TableCell>Name</TableCell><TableCell>Type</TableCell><TableCell align="right">Rate</TableCell><TableCell>Jurisdiction</TableCell><TableCell>Status</TableCell></TableRow></TableHead>
            <TableBody>
              {rates.map(r => (
                <TableRow key={r.id} sx={{ cursor: 'pointer' }} onClick={() => { setEditItem(r); setForm({ ...r }); setDialogOpen(true); }}>
                  <TableCell><strong>{r.code}</strong></TableCell>
                  <TableCell>{r.name}</TableCell>
                  <TableCell><Chip label={r.tax_type} size="small" /></TableCell>
                  <TableCell align="right">{parseFloat(r.rate).toFixed(2)}%</TableCell>
                  <TableCell>{r.jurisdiction}</TableCell>
                  <TableCell><Chip label={r.is_active ? 'Active' : 'Inactive'} size="small" color={r.is_active ? 'success' : 'default'} /></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{editItem ? 'Edit Tax Rate' : 'New Tax Rate'}</DialogTitle>
        <DialogContent><Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={6}><TextField fullWidth label="Code" value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value })} /></Grid>
          <Grid item xs={6}><TextField fullWidth label="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></Grid>
          <Grid item xs={6}><TextField fullWidth type="number" label="Rate (%)" value={form.rate} onChange={(e) => setForm({ ...form, rate: e.target.value })} /></Grid>
          <Grid item xs={6}><TextField fullWidth select label="Type" value={form.tax_type} onChange={(e) => setForm({ ...form, tax_type: e.target.value })}>{['gst', 'vat', 'sales_tax', 'withholding', 'other'].map(t => <MenuItem key={t} value={t}>{t}</MenuItem>)}</TextField></Grid>
          <Grid item xs={12}><TextField fullWidth label="Jurisdiction" value={form.jurisdiction} onChange={(e) => setForm({ ...form, jurisdiction: e.target.value })} /></Grid>
        </Grid></DialogContent>
        <DialogActions><Button onClick={() => setDialogOpen(false)}>Cancel</Button><Button variant="contained" onClick={handleSave}>Save</Button></DialogActions>
      </Dialog>
    </ModuleHub>
  );
};

export default TaxRatesPage;
